<template>
  <BaseDialog
    title="Загрузка участников"
    :dialog="dialog"
    :is-show-mode="false"
    :is-edit="true"
    :is-invalid="$v.$invalid"
    :save-btn-loading="saveBtnLoading"
    @close="closeModal"
    @save="save"
  >
    <UIFileInput
      v-if="dialog"
      v-model="file"
      label="Загрузите предзаполненный файл excel"
      :error-messages="errorMessages.file"
      @removeFile="file = null"
      @input="$v.file.$touch()"
    />
  </BaseDialog>
</template>

<script>
import BaseDialog from '@/ui/dialog/BaseDialog'
import { FormTemplate } from '@/models'
import { setValidateMessages } from '@/scripts/validation'
import { required } from 'vuelidate/lib/validators'
import UIFileInput from '@/ui/input/file/UIFileInput'

export default {
  components: {
    UIFileInput,
    BaseDialog,
  },

  props: {
    saveBtnLoading: Boolean,
    dialog: Boolean,
  },

  data: () => ({
    formTemplate: new FormTemplate(),
    file: null,
  }),

  validations() {
    return {
      file: {
        required,
        fileTypeJpgAndPng: (item) => Boolean(item && item?.type === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'),
      },
    }
  },

  computed: {
    errorMessages() {
      const allErrors = {}

      Object.keys(this.$v.$params).forEach((key) => {
        allErrors[key] = setValidateMessages(this.$v[key])
      })

      return allErrors
    },
  },

  methods: {
    save() {
      this.$emit('saveFormTemplateExcel', this.file)
    },

    resetModal() {
      this.file = null
      this.$v.$reset()
    },

    closeModal() {
      this.$emit('closeModal')
    },
  },

  watch: {
    dialog(val) {
      !val && this.resetModal()
    },
  },
}
</script>
